/**
 * A stricter type guard.
 * @see https://tsplay.dev/WK8zGw
 */
export const hasOwnPropertyAlt = (object, property) => {
    return Object.prototype.hasOwnProperty.call(object, property);
};
//# sourceMappingURL=hasOwnPropertyAlt.js.map